/* eslint-disable no-unreachable */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row, Tag } from 'antd';
import classNames from 'classnames';
import { Header } from 'components/header';
import { EpDomain } from 'types/graphql-types';
import styles from './styles.less';

export type DomainsFormProps = {
  domains: EpDomain[];
};

const HORIZONTAL_GAP = 0;
const VERTICAL_GAP = 6;

export const DomainsView: FC<DomainsFormProps> = ({ domains }) => {
  const { t } = useTranslation();
  const emDash = '—';
  let emptyDomain;

  if (!domains.length) {
    emptyDomain = { desc: emDash, name: emDash };
  }

  return (
    <Row>
      <Col span={19}>
        <Row className={classNames(styles['row'], styles['header-row'])}>
          <Col span={13}>
            <Header level={5} className={styles['header']}>
              {t('Domain name')}
            </Header>
          </Col>
          <Col span={11}>
            <Header level={5} className={styles['header']}>
              {t('Sphere')}
            </Header>
          </Col>
        </Row>
        {emptyDomain && (
          <Row
            key={emDash}
            gutter={[HORIZONTAL_GAP, VERTICAL_GAP]}
            className={classNames(styles['row'], styles['data-row'])}
          >
            <Col span={13}> {emptyDomain.name} </Col>
            <Col span={11}>
              <div className={styles['sphere']}>{emptyDomain.desc}</div>
            </Col>
          </Row>
        )}
        {domains.map((domain) => (
          <Row
            key={`${domain.name}-${domain?.subDomains?.toString() || ''}`}
            gutter={[HORIZONTAL_GAP, VERTICAL_GAP]}
            className={classNames(styles['row'], styles['data-row'])}
          >
            <Col span={13}>
              <Tag>{domain?.name}</Tag>
            </Col>
            <Col span={11}>
              <div className={styles['sphere']}>{domain?.subDomains?.[0]}</div>
            </Col>
          </Row>
        ))}
      </Col>
    </Row>
  );
};
